<template>
    <div id="ComponentModalProcessoHistorico">
        <div class="modal fade modern-modal" id="ModalProcessoHistorico" tabindex="-1" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">

                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            :disabled="loading"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 5.67541V3C3 2.44772 2.55228 2 2 2C1.44772 2 1 2.44772 1 3V7C1 8.10457 1.89543 9 3 9H7C7.55229 9 8 8.55229 8 8C8 7.44772 7.55229 7 7 7H4.52186C4.54218 6.97505 4.56157 6.94914 4.57995 6.92229C5.621 5.40094 7.11009 4.22911 8.85191 3.57803C10.9074 2.80968 13.173 2.8196 15.2217 3.6059C17.2704 4.3922 18.9608 5.90061 19.9745 7.8469C20.9881 9.79319 21.2549 12.043 20.7247 14.1724C20.1945 16.3018 18.9039 18.1638 17.0959 19.4075C15.288 20.6513 13.0876 21.1909 10.9094 20.9247C8.73119 20.6586 6.72551 19.605 5.27028 17.9625C4.03713 16.5706 3.27139 14.8374 3.06527 13.0055C3.00352 12.4566 2.55674 12.0079 2.00446 12.0084C1.45217 12.0088 0.995668 12.4579 1.04626 13.0078C1.25994 15.3309 2.2082 17.5356 3.76666 19.2946C5.54703 21.3041 8.00084 22.5931 10.6657 22.9188C13.3306 23.2444 16.0226 22.5842 18.2345 21.0626C20.4464 19.541 22.0254 17.263 22.6741 14.6578C23.3228 12.0526 22.9963 9.30013 21.7562 6.91897C20.5161 4.53782 18.448 2.69239 15.9415 1.73041C13.4351 0.768419 10.6633 0.756291 8.14853 1.69631C6.06062 2.47676 4.26953 3.86881 3 5.67541Z" fill="currentColor" />
                                <path d="M12 5C11.4477 5 11 5.44771 11 6V12.4667C11 12.4667 11 12.7274 11.1267 12.9235C11.2115 13.0898 11.3437 13.2344 11.5174 13.3346L16.1372 16.0019C16.6155 16.278 17.2271 16.1141 17.5032 15.6358C17.7793 15.1575 17.6155 14.546 17.1372 14.2698L13 11.8812V6C13 5.44772 12.5523 5 12 5Z" fill="currentColor" />
                            </svg>
                        </div>

                        <div class="header-text">
                            <h2>Histórico do processo</h2>
                            <p>Consulte os dados do processo e o histórico de cada artefato.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div v-if="loading" class="historico-loading">
                            <span class="spinner-border spinner-border-sm me-2"></span>
                            Carregando histórico...
                        </div>

                        <template v-else>
                        <section class="info-card">
                            <div class="section-heading">
                                <h3>Dados do processo</h3>
                                <span class="status-chip" :class="processo.flFinalizado ? 'status-chip-muted' : 'status-chip-success'">
                                    {{ processo.flFinalizado ? 'Finalizado' : 'Ativo' }}
                                </span>
                            </div>

                            <div class="info-grid">
                                <div class="info-item info-item-wide">
                                    <span class="info-label">Nome</span>
                                    <span class="info-value">{{ processo.dsNome || '—' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Número</span>
                                    <span class="info-value">{{ processo.cdProcesso || '—' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Tipo</span>
                                    <span class="info-value">{{ processo.nmTipoProcesso || '—' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Legislação</span>
                                    <span class="info-value">{{ processo.nmLegislacao || '—' }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Data de criação</span>
                                    <span class="info-value">{{ formatarData(processo.dtInclusao) }}</span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Usuário responsável</span>
                                    <span class="info-value info-value-user">
                                        <span class="user-initials">{{ iniciais(processo.nmUsuarioResponsavel) }}</span>
                                        {{ processo.nmUsuarioResponsavel || '—' }}
                                    </span>
                                </div>
                                <div class="info-item">
                                    <span class="info-label">Finalização estimada</span>
                                    <span class="info-value">{{ formatarData(processo.dtFinalizacaoEstimada) }}</span>
                                </div>
                            </div>
                        </section>

                        <section class="artefatos-section">
                            <div class="section-heading">
                                <div>
                                    <h3>Histórico por artefato</h3>
                                    <p class="section-hint">Expanda um artefato para ver a linha do tempo de histórico e de status.</p>
                                </div>
                                <span class="info-chip">{{ artefatos.length }} {{ artefatos.length === 1 ? 'artefato' : 'artefatos' }}</span>
                            </div>

                            <div v-if="!artefatos.length" class="empty-state">
                                <p class="empty-title">Nenhum artefato neste processo</p>
                                <p class="empty-description">Quando houver geração ou tramitação, o histórico aparece aqui.</p>
                            </div>

                            <div v-else class="artefato-list">
                                <article v-for="artefato in artefatos"
                                         :key="artefato.idProcessoModeloArtefato"
                                         class="artefato-card"
                                         :class="{ 'is-open': artefatoAbertoId === artefato.idProcessoModeloArtefato }">
                                    <button type="button"
                                            class="artefato-header"
                                            @click="alternarArtefato(artefato.idProcessoModeloArtefato)">
                                        <div class="artefato-icon">
                                            <i class="far fa-file-alt"></i>
                                        </div>
                                        <div class="artefato-title-block">
                                            <h4>{{ artefato.nmModelo }}</h4>
                                            <span class="artefato-meta">
                                                {{ (artefato.eventos || []).length }} {{ (artefato.eventos || []).length === 1 ? 'evento' : 'eventos' }}
                                            </span>
                                        </div>
                                        <span class="status-chip" :class="statusChipClass(artefato.nmStatusAtual)">
                                            {{ artefato.nmStatusAtual || 'Sem status' }}
                                        </span>
                                        <svg class="artefato-chevron" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                        </svg>
                                    </button>

                                    <div v-show="artefatoAbertoId === artefato.idProcessoModeloArtefato" class="artefato-body">
                                        <ul v-if="artefato.eventos && artefato.eventos.length" class="timeline">
                                            <li v-for="(evento, idx) in artefato.eventos"
                                                :key="idx"
                                                class="timeline-item"
                                                :class="['is-' + (evento.tpEvento || 'info'), 'origem-' + (evento.origem || 'historico')]">
                                                <div class="timeline-dot"></div>
                                                <div class="timeline-content">
                                                    <div class="timeline-top">
                                                        <strong>
                                                            {{ evento.dsMovimento }}
                                                            <span class="timeline-origem" :class="'origem-' + (evento.origem || 'historico')">
                                                                {{ evento.origem === 'status' ? 'Status' : 'Histórico' }}
                                                            </span>
                                                        </strong>
                                                        <time>{{ formatarDataHora(evento.dtInclusao) }}</time>
                                                    </div>
                                                    <p v-if="evento.dsDetalhes" class="timeline-detail">{{ evento.dsDetalhes }}</p>
                                                    <span class="timeline-user">
                                                        <span class="user-initials user-initials-sm">{{ iniciais(evento.nmUsuario) }}</span>
                                                        {{ evento.nmUsuario || '—' }}
                                                    </span>
                                                </div>
                                            </li>
                                        </ul>
                                        <p v-else class="timeline-empty">Nenhum evento registrado neste artefato.</p>
                                    </div>
                                </article>
                            </div>
                        </section>
                        </template>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button"
                                class="modern-btn modern-btn-secondary"
                                data-bs-dismiss="modal">
                            Fechar
                        </button>
                        <button type="button"
                                class="modern-btn modern-btn-primary"
                                :disabled="loading || baixandoPdf"
                                @click="baixarPdf">
                            <i class="fas fa-file-pdf"></i>
                            {{ baixandoPdf ? 'Gerando PDF...' : 'Baixar PDF' }}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { urlApi, avisoErro } from '@/config/global'

    export default {
        name: 'ModalProcessoHistorico',
        props: {
            idProcesso: { type: Number, default: () => 0 }
        },

        data() {
            return {
                bsModal: null,
                onHidden: null,
                loading: false,
                baixandoPdf: false,
                idConsulta: 0,
                artefatoAbertoId: null,
                processo: this.processoVazio(),
                artefatos: [],
            }
        },

        mounted() {
            const el = document.getElementById('ModalProcessoHistorico')
            const bs = window.bootstrap || window.Bootstrap
            if (el && bs?.Modal) this.bsModal = new bs.Modal(el, { focus: false })

            this.onHidden = () => this.onModalHidden()
            if (el) el.addEventListener('hidden.bs.modal', this.onHidden)
        },

        beforeDestroy() {
            const el = document.getElementById('ModalProcessoHistorico')
            if (el && this.onHidden) el.removeEventListener('hidden.bs.modal', this.onHidden)
        },

        methods: {
            abrir(idProcesso) {
                this.reset()
                this.idConsulta = idProcesso || this.idProcesso
                this.bsModal?.show?.()
                this.getHistoricoProcesso()
            },

            onModalHidden() {
                this.reset()
            },

            reset() {
                this.loading = false
                this.idConsulta = 0
                this.artefatoAbertoId = null
                this.processo = this.processoVazio()
                this.artefatos = []
            },

            processoVazio() {
                return {
                    dsNome: '',
                    cdProcesso: '',
                    nmTipoProcesso: '',
                    nmLegislacao: '',
                    dtInclusao: null,
                    nmUsuarioResponsavel: '',
                    dtFinalizacaoEstimada: null,
                    flFinalizado: false,
                }
            },

            getHistoricoProcesso() {
                const id = this.idConsulta || this.idProcesso
                if (!id) {
                    avisoErro('Processo inválido.')
                    return
                }

                this.loading = true
                axios.get(`${urlApi}/Processo/GetHistorico/${id}`)
                    .then(res => {
                        if (res.data?.success) {
                            this.aplicarHistorico(res.data.data)
                        } else {
                            avisoErro(res.data?.msg || 'Não foi possível carregar o histórico.')
                        }
                    })
                    .catch(err => {
                        if (err.response?.data) avisoErro(err.response.data)
                        else avisoErro('Não foi possível carregar o histórico.')
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },

            aplicarHistorico(dados) {
                const proc = dados?.processo || {}
                this.processo = {
                    dsNome: proc.dsNome || '',
                    cdProcesso: proc.cdProcesso || '',
                    nmTipoProcesso: dados?.tipoProcesso?.nmTipoProcesso || '',
                    nmLegislacao: dados?.legislacao?.dsNome || '',
                    dtInclusao: proc.dtInclusao || null,
                    nmUsuarioResponsavel: dados?.proprietario?.nmUsuario || proc.dsLogin || '',
                    dtFinalizacaoEstimada: proc.dtFinalizacaoEstimada || null,
                    flFinalizado: !!proc.flFinalizado,
                }

                const lista = dados?.lstProcessoModeloArtefatoHistorico || []
                this.artefatos = lista.map(item => ({
                    idProcessoModeloArtefato: item.idProcessoModeloArtefato,
                    nmModelo: item.nmModelo || item.processoModeloArtefato?.nmModelo || 'Artefato',
                    nmStatusAtual: item.nmStatusAtual || '',
                    eventos: this.montarEventos(item),
                }))

                this.artefatoAbertoId = this.artefatos[0]?.idProcessoModeloArtefato || null
            },

            montarEventos(item) {
                const lstHistorico = this.listaCampo(item, [
                    'lstProcessoArtefatoHistorico',
                    'LstProcessoArtefatoHistorico',
                ])
                const lstStatus = this.listaCampo(item, [
                    'lstProcessoArtefatoStatusHistorico',
                    'lstStatusHistorico',
                    'LstProcessoArtefatoStatusHistorico',
                    'LstStatusHistorico',
                ])

                const movimentos = lstHistorico.map(ev => ({
                    dtInclusao: ev.dtInclusao,
                    dsMovimento: ev.dsMovimento || 'Movimento',
                    dsDetalhes: ev.dsDetalhes,
                    nmUsuario: ev.nmUsuario,
                    origem: 'historico',
                    tpEvento: this.tpEventoPorTexto(ev.dsMovimento || ev.dsStatus),
                }))

                const status = lstStatus.map(ev => ({
                    dtInclusao: ev.dtInclusao,
                    dsMovimento: ev.nmTipoStatusHistorico || 'Status',
                    dsDetalhes: ev.dsTipoStatusHistorico,
                    nmUsuario: ev.nmUsuario || ev.nmUsuarioInclusao,
                    origem: 'status',
                    tpEvento: this.tpEventoPorTexto(ev.nmTipoStatusHistorico),
                }))

                return movimentos.concat(status).sort((a, b) => {
                    return new Date(a.dtInclusao) - new Date(b.dtInclusao)
                })
            },

            listaCampo(item, nomes) {
                for (const nome of nomes) {
                    const valor = item?.[nome]
                    if (Array.isArray(valor) && valor.length) return valor
                }
                for (const nome of nomes) {
                    const valor = item?.[nome]
                    if (Array.isArray(valor)) return valor
                }
                return []
            },

            tpEventoPorTexto(texto) {
                const s = (texto || '').toLowerCase()
                if (s.includes('finalizado') || s.includes('aprovad') || s.includes('assinad') || s.includes('revisado')) return 'success'
                if (s.includes('aguardando') || s.includes('revisão') || s.includes('aprovação') || s.includes('pendente')) return 'warning'
                return 'info'
            },

            baixarPdf() {
                const id = this.idConsulta || this.idProcesso
                if (!id || this.baixandoPdf) return

                this.baixandoPdf = true
                axios({
                    method: 'GET',
                    url: `${urlApi}/Processo/DownloadHistoricoPdf/${id}`,
                    responseType: 'blob',
                    showLoading: true,
                })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/pdf' })
                        const link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        const numero = (this.processo.cdProcesso || String(id)).replace(/[^\w-]+/g, '_')
                        link.download = `historico_processo_${numero}.pdf`
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        URL.revokeObjectURL(link.href)
                    })
                    .catch(async error => {
                        let msg = 'Não foi possível gerar o PDF do histórico.'
                        const data = error?.response?.data
                        if (data instanceof Blob) {
                            try {
                                const json = JSON.parse(await data.text())
                                msg = json.msg || json.errors?.[0] || msg
                            } catch (e) { /* resposta não é JSON */ }
                        } else if (error?.response?.data?.msg) {
                            msg = error.response.data.msg
                        }
                        avisoErro(msg)
                    })
                    .finally(() => {
                        this.baixandoPdf = false
                    })
            },

            alternarArtefato(id) {
                this.artefatoAbertoId = this.artefatoAbertoId === id ? null : id
            },

            iniciais(nome) {
                if (!nome) return '—'
                const partes = nome.trim().split(/\s+/).filter(Boolean)
                if (!partes.length) return '—'
                if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase()
                return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase()
            },

            formatarData(dataISO) {
                if (!dataISO) return '—'
                return new Date(dataISO).toLocaleDateString('pt-BR')
            },

            formatarDataHora(dataISO) {
                if (!dataISO) return '—'
                const data = new Date(dataISO)
                return `${data.toLocaleDateString('pt-BR')} ${data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
            },

            statusChipClass(status) {
                const s = (status || '').toLowerCase()
                if (s.includes('finalizado') || s.includes('aprovad') || s.includes('assinad') || s.includes('revisado')) return 'status-chip-success'
                if (s.includes('aprovação') || s.includes('revisão') || s.includes('pendente')) return 'status-chip-warning'
                if (s.includes('elaboração') || s.includes('gerado')) return 'status-chip-info'
                return 'status-chip-muted'
            },
        }
    }
</script>

<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: calc(100vw - 40px) !important;
        margin: auto;
        margin-top: 20px;
        padding: 0 12px;
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
        max-height: calc(100vh - 40px);
        display: flex;
        flex-direction: column;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
        z-index: 1;
        flex-shrink: 0;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

        .modal-modern-header .header-icon {
            width: 64px;
            height: 64px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
            color: #2563eb;
            flex-shrink: 0;
        }

        .modal-modern-header .header-text {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 6px;
        }

            .modal-modern-header .header-text h2 {
                margin: 0;
                font-size: 24px;
                font-weight: 700;
                color: #0f172a;
            }

            .modal-modern-header .header-text p {
                margin-top: 6px;
                margin-bottom: 0;
                color: #475569;
                font-size: 14px;
                max-width: 520px;
                line-height: 1.4;
            }

    .modal-modern-body {
        padding: 28px 32px 16px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        overflow: auto;
        min-height: 0;
    }

    .historico-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 180px;
        color: #475569;
        font-size: 14px;
        font-weight: 600;
    }

    .modal-modern-footer {
        padding: 8px 32px 28px;
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        flex-wrap: wrap;
        flex-shrink: 0;
    }

    .section-heading {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 16px;
    }

        .section-heading h3 {
            margin: 0;
            font-size: 16px;
            font-weight: 700;
            color: #0f172a;
        }

    .section-hint {
        margin: 4px 0 0;
        font-size: 13px;
        color: #64748b;
    }

    .info-chip {
        display: inline-flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        color: #2563eb;
        background: rgba(37, 99, 235, 0.12);
        white-space: nowrap;
    }

    .info-card,
    .artefato-card {
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.06);
    }

    .info-card {
        padding: 22px 24px 20px;
    }

    .info-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 16px 20px;
    }

    .info-item {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
    }

    .info-item-wide {
        grid-column: 1 / -1;
    }

    .info-label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #64748b;
    }

    .info-value {
        font-size: 14px;
        font-weight: 600;
        color: #0f172a;
        word-break: break-word;
    }

    .info-value-user {
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .user-initials {
        width: 28px;
        height: 28px;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-weight: 700;
        color: #1d4ed8;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid #bfdbfe;
        flex-shrink: 0;
    }

    .user-initials-sm {
        width: 22px;
        height: 22px;
        font-size: 10px;
    }

    .status-chip {
        display: inline-flex;
        align-items: center;
        padding: 5px 10px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 12px;
        border: 1px solid transparent;
        white-space: nowrap;
    }

    .status-chip-success {
        background: rgba(16, 185, 129, 0.12);
        color: #047857;
        border-color: rgba(16, 185, 129, 0.35);
    }

    .status-chip-warning {
        background: rgba(245, 158, 11, 0.14);
        color: #92400e;
        border-color: rgba(245, 158, 11, 0.35);
    }

    .status-chip-info {
        background: rgba(37, 99, 235, 0.12);
        color: #1d4ed8;
        border-color: rgba(37, 99, 235, 0.28);
    }

    .status-chip-muted {
        background: rgba(148, 163, 184, 0.16);
        color: #475569;
        border-color: rgba(148, 163, 184, 0.35);
    }

    .artefato-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .artefato-header {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 16px 18px;
        background: transparent;
        border: 0;
        text-align: left;
        cursor: pointer;
    }

        .artefato-header:hover {
            background: rgba(241, 245, 249, 0.7);
        }

    .artefato-icon {
        width: 40px;
        height: 40px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        flex-shrink: 0;
    }

    .artefato-title-block {
        flex: 1;
        min-width: 0;
    }

        .artefato-title-block h4 {
            margin: 0;
            font-size: 15px;
            font-weight: 700;
            color: #0f172a;
        }

    .artefato-meta {
        font-size: 12px;
        color: #64748b;
    }

    .artefato-chevron {
        color: #64748b;
        transition: transform 0.2s ease;
        flex-shrink: 0;
    }

    .artefato-card.is-open .artefato-chevron {
        transform: rotate(180deg);
    }

    .artefato-body {
        padding: 0 18px 18px 72px;
        border-top: 1px solid rgba(148, 163, 184, 0.16);
    }

    .timeline {
        list-style: none;
        margin: 16px 0 0;
        padding: 0;
        position: relative;
    }

        .timeline::before {
            content: '';
            position: absolute;
            left: 6px;
            top: 6px;
            bottom: 6px;
            width: 2px;
            background: rgba(148, 163, 184, 0.35);
        }

    .timeline-item {
        position: relative;
        padding: 0 0 16px 24px;
    }

        .timeline-item:last-child {
            padding-bottom: 0;
        }

    .timeline-dot {
        position: absolute;
        left: 1px;
        top: 6px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #2563eb;
        border: 2px solid #fff;
        box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.25);
    }

    .timeline-item.is-success .timeline-dot {
        background: #10b981;
        box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.25);
    }

    .timeline-item.is-warning .timeline-dot {
        background: #f59e0b;
        box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.25);
    }

    .timeline-top {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 12px;
        flex-wrap: wrap;
    }

        .timeline-top strong {
            font-size: 14px;
            color: #0f172a;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            flex-wrap: wrap;
        }

        .timeline-top time {
            font-size: 12px;
            color: #64748b;
            white-space: nowrap;
        }

    .timeline-origem {
        display: inline-flex;
        align-items: center;
        padding: 2px 8px;
        border-radius: 999px;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        line-height: 1.4;
    }

        .timeline-origem.origem-historico {
            background: rgba(37, 99, 235, 0.12);
            color: #1d4ed8;
        }

        .timeline-origem.origem-status {
            background: rgba(124, 58, 237, 0.12);
            color: #6d28d9;
        }

    .timeline-item.origem-status .timeline-dot {
        background: #7c3aed;
        box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.25);
    }

    .timeline-detail {
        margin: 4px 0 6px;
        font-size: 13px;
        color: #475569;
    }

    .timeline-user {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        font-weight: 600;
        color: #334155;
    }

    .timeline-empty {
        margin: 16px 0 0;
        font-size: 13px;
        color: #64748b;
    }

    .empty-state {
        text-align: center;
        padding: 36px 16px;
        border-radius: 18px;
        border: 1px dashed rgba(148, 163, 184, 0.4);
        background: #fff;
    }

    .empty-title {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 6px 0 0;
        font-size: 13px;
        color: #64748b;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        min-height: 44px;
        transition: all 0.2s ease;
    }

    .modern-btn-secondary {
        background: #f1f5f9;
        color: #334155;
        border: 1px solid rgba(148, 163, 184, 0.35);
    }

        .modern-btn-secondary:hover {
            background: #e2e8f0;
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
        box-shadow: 0 8px 20px rgba(37, 99, 235, 0.28);
    }

        .modern-btn-primary:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 24px rgba(37, 99, 235, 0.35);
        }

        .modern-btn-primary:disabled {
            opacity: 0.65;
            transform: none;
            cursor: not-allowed;
        }

    .btn-close-modern {
        z-index: 2;
    }

    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding-left: 20px;
            padding-right: 20px;
        }

        .modal-modern-header {
            flex-direction: column;
        }

        .artefato-body {
            padding-left: 18px;
        }

        .artefato-header {
            flex-wrap: wrap;
        }

        .info-item-wide {
            grid-column: auto;
        }

        .modal-modern-footer .modern-btn {
            flex: 1 1 100%;
        }
    }

    [data-bs-theme="dark"] .historico-loading {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2,
    [data-bs-theme="dark"] .section-heading h3,
    [data-bs-theme="dark"] .info-value,
    [data-bs-theme="dark"] .artefato-title-block h4,
    [data-bs-theme="dark"] .timeline-top strong,
    [data-bs-theme="dark"] .empty-title {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p,
    [data-bs-theme="dark"] .section-hint,
    [data-bs-theme="dark"] .info-label,
    [data-bs-theme="dark"] .artefato-meta,
    [data-bs-theme="dark"] .timeline-detail,
    [data-bs-theme="dark"] .timeline-top time,
    [data-bs-theme="dark"] .empty-description {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .info-card,
    [data-bs-theme="dark"] .artefato-card,
    [data-bs-theme="dark"] .empty-state {
        background: #1e293b;
        border-color: rgba(148, 163, 184, 0.2);
    }

    [data-bs-theme="dark"] .artefato-header:hover {
        background: rgba(30, 41, 59, 0.9);
    }

    [data-bs-theme="dark"] .artefato-body {
        border-top-color: rgba(148, 163, 184, 0.18);
    }

    [data-bs-theme="dark"] .timeline::before {
        background: rgba(148, 163, 184, 0.28);
    }

    [data-bs-theme="dark"] .timeline-dot {
        border-color: #1e293b;
    }

    [data-bs-theme="dark"] .timeline-origem.origem-historico {
        background: rgba(59, 130, 246, 0.2);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .timeline-origem.origem-status {
        background: rgba(167, 139, 250, 0.2);
        color: #c4b5fd;
    }

    [data-bs-theme="dark"] .timeline-user {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .user-initials {
        background: rgba(37, 99, 235, 0.2);
        color: #93c5fd;
        border-color: rgba(59, 130, 246, 0.4);
    }

    [data-bs-theme="dark"] .modern-btn-secondary {
        background: #1e293b;
        color: #e2e8f0;
        border-color: rgba(148, 163, 184, 0.28);
    }

    [data-bs-theme="dark"] .modern-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

    [data-bs-theme="dark"] .info-chip {
        background: rgba(37, 99, 235, 0.18);
        color: #93c5fd;
    }
</style>
